// 意大利语
export default {
    login: {
        t01: 'Lingua',
        t02: 'Netflix',
        t03: 'Inserisci il tuo nome utente',
        t04: 'Inserisci la tua password',
        t05: 'Accedi',
        t06: 'Registrati',
        t07: 'Inserisci il tuo numero di telefono',
        t08: 'Conferma Password',
        t09: 'Inserisci il codice di invito',
        t10: 'Registra Account',
        t11: 'Conferma la tua password',
        t13: 'L’amore per il cinema può portarti ad accumulare una notevole ricchezza senza che tu te ne accorga.',
        t14: 'Accesso Riuscito',
        t15: 'Le password non corrispondono',
        t16: 'Registrazione Riuscita',
        t17: 'Errore di Rete',
        t18: 'Richiesta scaduta, controlla la tua connessione di rete'
    },
    cover_info: {
        t01: 'Inizia a Guadagnare',
        t02: 'Ricarica Monete',
        t03: 'Preleva Monete',
        t04: 'Certificati'
    },
    cont: {
        t01: 'Scegli Lingua',
        t02: 'Tutti',
        t03: 'In Attesa',
        t04: 'Completato',
        t05: 'Congelato',
        t06: 'Il Mio Saldo',
        t07: 'Incompleto',
        t08: 'Ordini Totali',
        t09: 'Commissione',
        t10: 'Commissione Guadagnata',
        t11: 'Numero di Ordini',
        t12: 'Saldo Disponibile',
        t13: 'Inizia a Prendere Ordini',
        t14: 'Fondi Account',
        t15: 'Invia Ordine',
        t16: 'Tutti gli Ordini Inviati',
        t17: 'Orario Ordine',
        t18: 'Numero Ordine',
        t19: 'Importo Totale Ordine',
        t21: 'Opera',
        t22: 'Attore',
        t23: 'Commenti sull’opera',
        t24: 'Annulla',
        t25: 'Scegli Valutazione',
        t26: 'Invio Ordine Completato',
        t27: 'Ordine Acquisito',
        t28: 'Acquisizione Riuscita',
        t29: 'Acquisizione Ordine Fallita, Riprova Più Tardi!'
    },
    user: {
        t1: 'Codice Referral',
        t2: 'Saldo',
        t3: 'Saldo Disponibile',
        t4: 'Guadagni Totali',
        t5: 'Preleva',
        t6: 'Cronologia Depositi',
        t7: 'Cronologia Prelievi',
        t8: 'Dettagli Account',
        t9: 'Messaggi',
        t10: 'Connetti Carta Bancaria',
        t11: 'Cambia Password',
        t12: 'Cambia Password Prelievo',
        t13: 'Invita Amici',
        t14: 'Scegli Lingua',
        t15: 'Esci',
        t16: 'Preleva',
        t17: 'Importo da Prelevare',
        t18: 'Nome Account',
        t19: 'Numero di Telefono',
        t20: 'Importo da Prelevare',
        t21: 'Preleva',
        t22: 'Inserisci l\'importo da prelevare',
        t23: 'Inserisci la password dei fondi virtuali',
        t24: 'Totale Depositato',
        t25: 'Messaggi di Sistema',
        t26: 'Dettagli Carta Bancaria',
        t27: 'Lista Banche',
        t28: 'Nome Banca',
        t29: 'Alias',
        t30: 'Numero Carta Bancaria',
        t31: 'Numero di Telefono',
        t32: 'Conferma Modifiche',
        t33: 'Inserisci il numero di conto e il codice IFSC della tua carta bancaria collegata. Assicurati di inserire correttamente il tuo nome e numero di telefono, altrimenti l\'importo depositato non verrà ricevuto.',
        t34: 'Password Precedente',
        t35: 'Nuova Password',
        t36: 'Conferma Password',
        t37: 'Continua',
        t38: 'Ricorda la tua password. Se hai dimenticato la password, contatta il servizio clienti.',
        t39: 'Copia Link Invito',
        t40: 'Invita amici per guadagnare più benefici',
        t41: 'Deposita',
        t42: 'Conferma',
        t43: 'Annulla',
        t44: 'Sei sicuro di voler uscire?',
        t45: 'Importo Depositato',
        t46: 'Il deposito è stato effettuato con successo',
        t47: 'Verifica Completata',
        t48: 'In Attesa di Verifica',
        t49: 'Totale Prelevato',
        t50: 'Imposta prima la password di prelievo',
        t51: 'Inserisci la password precedente',
        t52: 'Inserisci la nuova password',
        t53: 'Conferma Password',
        t54: 'Le password inserite non corrispondono',
        t55: 'Copiato',
        t56: 'L\'importo del prelievo non può essere inferiore a 30',
        t57: 'Inviato con successo, reindirizzamento',
        t58: 'Revisione fallita',
        t59: 'Imposta Avatar',
        t60: 'Imposta Ora',
        t61: 'Impostazione Riuscita',
        t62: 'Dopo l\'approvazione del portafoglio, devi accedere per prelevare denaro',
        t63: 'Prelievo su carta bancaria',
        t64: 'Prelievo su USDT (rapporto 1:0.013)',
        t65: 'Numero Conto Bancario',
        t66: 'Inserisci il numero di conto bancario e il codice IFSC per la carta bancaria che desideri collegare, insieme al tuo nome completo e numero di cellulare. Assicurati che tutte le informazioni siano accurate per facilitare le transazioni di pagamento.',
        t67: 'Collega prima la tua carta bancaria',
        t68: 'Ricarica utente',
        t69: 'Utente accetta ordini',
        t70: 'Commissione subordinati',
        t71: 'Prelievo utente',
        t72: 'Trasferisci in Yebao',
        t73: 'Trasferisci da Yebao',
        t74: 'Guadagni Yebao',
        t75: 'Commissione ordini',
        t76: 'Saldo inferiore a 30, impossibile continuare le operazioni, contatta il servizio clienti',
        t77: 'Inserisci il nome della banca',
        t78: 'Inserisci il numero di conto bancario',
        t80: 'Inserisci il tuo nome completo',
        t81: 'Inserisci il tuo numero di telefono',
        t82: 'Inserisci l\'importo del prelievo',
        t83: 'Copia',
        t84: 'Top 100 Giornaliero: Globale',
        t85: 'Ascolta',
        t86: "Email",
        t87: "Inserisci la tua email",
        t88: "Codice Bancario",
        t89: "Inserisci il codice bancario",
        t90: 'Bonifico Bancario',
        t91: '1. Non è prevista alcuna commissione per i prelievi',
        t92: '2. Il prelievo verrà accreditato con successo entro 10-15 minuti dopo la richiesta. Per i prelievi effettuati fuori dall’orario lavorativo, l’accredito avverrà nel successivo orario lavorativo.'
    },
    movie: {
        t01: 'Film e programmi TV popolari',
        t02: 'Password dei fondi',
        t03: 'Differenza dell’ordine',
        t04: 'Gestione degli indirizzi on-chain',
        t05: 'Inserisci',
        t06: 'Inserisci l’indirizzo on-chain corretto e la rete corrispondente (ad es. ERC20/TRC20/BTC), altrimenti il pagamento/trasferimento potrebbe non arrivare o causare la perdita degli asset.',
        t07: 'Preleva su un indirizzo on-chain',
        t08: 'Aggiungi',
        t09: 'Aggiungi un indirizzo on-chain',
    },
    langType: '意大利语'
} 